import React, { Component } from 'react';

class Overlay extends Component {
  render() {
    return(
      <div className="site-overlay"></div>
    );
  }
}

export default Overlay



// WEBPACK FOOTER //
// ./src/components/overlay.js